const convertMdg2DateTimeResponse = (dateTimeUtc) => {
  if (dateTimeUtc === null) {
    return null;
  }
  const date = typeof dateTimeUtc === "string" ? new Date(dateTimeUtc) : new Date(dateTimeUtc * 1e3);
  return !isNaN(date.getTime()) ? date : null;
};
const getUTCDate = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
};
var FactsetFxMarket = /* @__PURE__ */ ((FactsetFxMarket2) => {
  FactsetFxMarket2[FactsetFxMarket2["FactSetFx"] = 405] = "FactSetFx";
  FactsetFxMarket2[FactsetFxMarket2["FactSetSyntheticFx"] = 406] = "FactSetSyntheticFx";
  return FactsetFxMarket2;
})(FactsetFxMarket || {});
const MODIFIERS = {
  S: 1e3,
  M: 60 * 1e3
};
const convertGranularityToMs = (granularity, defaultMs = 1e3) => {
  if (!granularity) {
    return defaultMs;
  }
  const modifier = granularity.substring(granularity.length - 1);
  const number = granularity.slice(0, -1);
  if (!MODIFIERS[modifier] || Number.isNaN(number)) {
    return defaultMs;
  }
  return parseInt(number, 10) * MODIFIERS[modifier];
};
const getClosestGranularity = (granularity, possibleValues, logger) => {
  if (possibleValues.includes(granularity)) {
    return granularity;
  }
  logger == null ? void 0 : logger.warn("Given granularity is not supported by endpoint. Setting granularity to closest value possible.");
  return possibleValues.reduce((previous, current) => {
    return Math.abs(current - granularity) < Math.abs(previous - granularity) ? current : previous;
  });
};
const getAssetClassId = (assetClass) => {
  var _a;
  const assetClassToIdMapping = {
    index: 1,
    bond: 5,
    commodity: 9,
    currency: 8,
    fund: 3,
    etf: 4,
    future: 11,
    interestRate: 12,
    investmentProduct: 6,
    leveragedProduct: 7,
    option: 10,
    stock: 2,
    generic: null
  };
  return (_a = assetClassToIdMapping[assetClass]) != null ? _a : null;
};
const mapAssetClass = (assetClass) => {
  switch (assetClass) {
    case "debt":
      return "bond";
    case "index":
    case "bond":
    case "commodity":
    case "currency":
    case "fund":
    case "etf":
    case "future":
    case "interestRate":
    case "investmentProduct":
    case "leveragedProduct":
    case "option":
    case "stock":
      return assetClass;
    default:
      return "generic";
  }
};
const getEndpointOptions = (endpointConfiguration, endpointModule) => {
  var _a, _b;
  const defaultEndpointOptions = (endpointConfiguration == null ? void 0 : endpointConfiguration.defaultVersion) ? { version: endpointConfiguration.defaultVersion } : void 0;
  return (_b = (_a = endpointConfiguration == null ? void 0 : endpointConfiguration.endpoints) == null ? void 0 : _a[endpointModule]) != null ? _b : defaultEndpointOptions;
};
const inheritEndpointOptions = (endpointConfiguration, componentOptions) => {
  if (!endpointConfiguration) {
    return componentOptions;
  }
  return {
    endpointConfiguration,
    ...componentOptions
  };
};
const getArrayValue = (array) => {
  if (array === null || array.length === 0) {
    return null;
  }
  return array;
};
const getUrl = (url, options) => {
  var _a;
  if (!url || url === "Media Not Available") {
    return null;
  }
  const baseUrl = (_a = options == null ? void 0 : options.externalUrl) == null ? void 0 : _a.base;
  if (baseUrl) {
    const urlObject = new URL(url);
    return baseUrl + urlObject.pathname + urlObject.search;
  }
  return url;
};
const getLanguage = (payloadLanguage, fallbackLanguage, options) => {
  var _a, _b;
  return (_b = (_a = options == null ? void 0 : options.language) != null ? _a : payloadLanguage == null ? void 0 : payloadLanguage.substring(0, 2)) != null ? _b : fallbackLanguage;
};
const getPercentage = (numerator, denumerator = 100) => {
  return numerator ? numerator / denumerator : numerator;
};

export { FactsetFxMarket, convertGranularityToMs, convertMdg2DateTimeResponse, getArrayValue, getAssetClassId, getClosestGranularity, getEndpointOptions, getLanguage, getPercentage, getUTCDate, getUrl, inheritEndpointOptions, mapAssetClass };
